import React from 'react'

const FilterButtons = ({filter, setFilter}) => {
  return (
    <div className='filters' style={{display:'flex', gap: "1rem"}}>
        <button
        className={`filter-btn ${filter === "all"? "active" : ""} `} 
        onClick={()=> setFilter("all")}>
          All
          </button>
        <button
        className={`filter-btn ${filter === "completed"? "active" : ""} `} 
        onClick={()=> setFilter("completed")}>
          Completed
        </button>
        <button
        className={`filter-btn ${filter === "uncompleted"? "active" : ""} `} 
        onClick={()=> setFilter("uncompleted")}>
          Uncompleted
        </button>
    </div>
  )
}

export default FilterButtons